export default {
  content: {
    class: [
      // Color
      'text-white dark:text-surface-950',
    ],
  },
  header: {
    class: [
      // Spacing
      'mb-4',
    ],
  },
  root: {
    class: [
      // Flex
      'flex flex-col',

      // Shape
      'rounded-lg',

      // Spacing
      'px-8 py-10',

      // Colors
      '!bg-surface-950 dark:!bg-surface-50',
    ],
  },
}
